import { Modal } from "react-bootstrap";
import Styles from "../Modal/ViewSettingsImage.module.css";
import cancelIcon from "../Assets/cross.png";

function ViewSettingimage(props) {
  return (
    <>
      <div
        className={Styles.parentContainer + " container-fluid"}
        id="imagesview"
      >
        <Modal
          size="sm"
          show={props?.showPopup}
          onHide={() => props?.onClose()}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          id="viewsettingsImage"
          backdrop="static" // ⛔ clicking outside will NOT close
          keyboard={false}
        >
          <Modal.Body>
            <div className={Styles.cancelImgParentContainer}>
              <div></div>
              <div className={Styles.cancelImgContainer}>
                <img
                  onClick={() => props?.onClose()}
                  src={cancelIcon}
                  alt="cancel"
                  className={Styles.cancelImg}
                />
              </div>
            </div>
            <div>
              <img
                src={props?.data?.image}
                alt="imageview"
                className={Styles.imagView}
              />
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}
export default ViewSettingimage;
